module.exports = __webpack_public_path__ + "img/check_animated_transparent.8fda99d1.svg";